import { render } from "./DayListItem.vue?vue&type=template&id=56df640f&scoped=true"
import script from "./DayListItem.vue?vue&type=script&lang=js"
export * from "./DayListItem.vue?vue&type=script&lang=js"

import "./DayListItem.vue?vue&type=style&index=0&id=56df640f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56df640f"]])

export default __exports__